/**
 * 群組管理 Hook
 * 管理群組列表、載入狀態，封裝群組相關的 API 調用
 */

import { useState, useCallback } from 'react';
import { fetchOrgGroups } from '../services/groupService';
import { buildGroupTree } from '../utils/treeUtils';

export const useGroups = (selectedOrg, getAccessToken, tokenRef, apiCall) => {
  const [groups, setGroups] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [loading, setLoading] = useState(false);

  /**
   * 獲取組織群組
   */
  const fetchGroups = useCallback(async () => {
    if (!selectedOrg) return;
    
    setLoading(true);
    try {
      const data = await fetchOrgGroups(selectedOrg, getAccessToken, tokenRef);
      setGroups(data);
      const tree = buildGroupTree(data, selectedOrg);
      setTreeData(tree);
    } catch (error) {
      console.error("Error fetching groups:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedOrg, getAccessToken, tokenRef]);

  return {
    groups,
    treeData,
    loading,
    fetchGroups,
    setGroups,
    setTreeData,
  };
};

